import React from 'react';

import PublicStore from 'Site/State/Store';
import { getBlogPosts } from 'Site/State/Actions';

import EmptyState from 'Core/Components/EmptyState';
import TagFilter from 'Core/Components/TagFilter';
import PhotoCard from 'Core/Components/PhotoCard';

class PostList extends React.Component {
  constructor (props) {
    super(props);
    const { id } = props;
    const filteredList = getBlogPosts(id);
    this.state = { filteredList };
    this.setFilteredList = this.setFilteredList.bind(this);
    this.renderPostItem = this.renderPostItem.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = PublicStore.subscribe(() => {
      const { id } = this.props;
      this.setState({ filteredList: getBlogPosts(id) });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  setFilteredList (filteredList) {
    this.setState({ filteredList });
  }

  renderPostItem (post, index) {
    const { id } = this.props;
    const { slug, title, caption, image } = post;
    const url = `/${id}/${slug}`;
    const card = { url, title, image, caption };

    return (
      <box className="xs-12 md-6" key={slug}>
        <PhotoCard card={card} />
      </box>
    );
  }

  render () {
    const { id } = this.props;
    const list = getBlogPosts(id);
    const { filteredList } = this.state;

    const tagList = !list ? null : list.reduce((caught, { tags }) => {
      const additions = tags.filter(tag => !caught.includes(tag));
      return [...caught, ...additions];
    }, []);

    return (
      <div>
        <TagFilter
          list={list}
          filters={tagList}
          onFilter={this.setFilteredList}
          allOption="All Blog Posts"
        />
        {!filteredList || !filteredList.length
          ? <EmptyState icon={'book'}>
              <p>Try adjusting your filters for different results.</p>
            </EmptyState>
          : <row className="PostList">{filteredList.reverse().map(this.renderPostItem)}</row>}
      </div>
    );
  }
};

export default PostList;



// WEBPACK FOOTER //
// ./client/Site/Ui/PostList.jsx